document.addEventListener("DOMContentLoaded", function() {
    let lang = $("html").attr("lang");
  
    // if (lang == "kz"){
    //     $("input[type=tel]").inputmask({"mask": "+\\9\\96(999) 999-99-99",
    //       showMaskOnHover: false,
    //       showMaskOnFocus: true
    //     });
    // }else{
    //   $("input[type=tel]").inputmask({"mask": "+7(999) 999-99-99",
    //       showMaskOnHover: false,
    //       showMaskOnFocus: true
    //   });
    // }


    $('.input-group input, .input-group textarea').on('focus', function () {
        $(this).closest('.input-group').addClass('input-group--focus');
    });
    $('.input-group-orders__input').on('keyup', function () {
        $(this).closest('.input-group').addClass('input-group--focus');
        if($(this).val().length){
            $(this).closest(".profile__change-name").addClass("no-empty")
        }else{
            $(this).closest(".profile__change-name").removeClass("no-empty")
        }
    });
    $('.input-group input, .input-group textarea').on('blur', function () {
        $(this).closest('.input-group').removeClass('input-group--focus');
        if ( $(this).val().length ) {
            $(this).closest('.input-group').addClass('input-group--notempty');
        } else {
            $(this).closest('.input-group').removeClass('input-group--notempty');
        }
    });
    $('.input-group input, .input-group textarea').each(function(){
      let $this = $(this);
      if($this.val()){
        $this.closest('.input-group').addClass('input-group--notempty');
      }
    })
    // $('input[type=tel]').inputmask({
    //     showMaskOnHover: false,
    //     showMaskOnFocus: true
    // });
    // data-inputmask='"mask": "+7(999) 999-99-99"' data-num-min='11' data-msg-checkMin='Введите весь номер' placeholder='+7(___) ___-__-__'

    $(document).on("click", ".price-toggler", function(){
        let $this = $(this);
        let price = $this.data("price");
        $this.closest("form").find("input.price-input").val(price);
    })
});